import React, { useState } from 'react';
import '../../Components/Page/Page.css';
import MainContent from '../../Content/MainContent/MainContent';
import Footer from '../../Components/Footer/FooterSmall';
import Header2 from '../../Components/Header2/Header2';
import Rotator from '../../Components/Rotator/Rotator';
// import VdoCipherComp from '../../Components/VdoCipher/VdoCipher';
import YouTubeVideo from '../../Components/VideoComp/YouTubeVideo';
import SecHeader from '../../Components/SecHeader/SecHeader';
import VCenterScroll from '../../Components/VScroll/VCenterScroll';
import LandingNews from '../../Content/LandingNews/LandingNews';
import ScrollPage, { SectionItem } from '../../Components/ScrollPage/ScrollPage';
import { useNavigate } from 'react-router-dom';
import InovationExData from '../../Content/InovationEx/InovationEx.json';
import {
  faArrowsDownToLine,
  faArrowsRotate,
  faBolt,
  faDumbbell,
  faGears,
  faLeaf,
  faShapes,
  faTemperature1,
  faWeightHanging,
} from '@fortawesome/free-solid-svg-icons';
import VdoCipherComp from '../../Components/VdoCipher/VdoCipher';

const innovationIcons = [
  faWeightHanging,
  faArrowsRotate,
  faShapes,
  faBolt,
  faGears,
  faTemperature1,
  faArrowsDownToLine,
  faDumbbell,
  faLeaf,
];

const innovationItems = (InovationExData as textAndBackground[]).map((item, index) => ({
  text: item.text,
  color: item.color,
  icon: innovationIcons[index],
}));

interface ScrollTo {
  index: number;
}

export const Sections: SectionItem[] = [
  { label: "Main Content", id: "landingMainContent" },
  { label: "Video", id: "landingVideo" }
];

const LandingPage1: React.FC<ScrollTo> = ({ index }) => {

  const navigate = useNavigate();
  const [isToggled, showVideo] = useState<boolean>(false);

  // Handler to toggle the state
  const handleToggle = () => {
    showVideo((prev: boolean) => !prev);
  };

  const scrollToVideo = () => {
    navigate("/landingVideo");
  }



  return (

    <div className='generalPageOverflow'>
      {/* <Header2 /> */}
      <Rotator />
      {/* <div className='pageContainer'> */}
      <ScrollPage index={index} sections={Sections} offsetTop={350}>
        <MainContent onClick={scrollToVideo} />
        {/* {isToggled && ( */}
        <div id="landingVideo">
          {/* <SecHeader title="A new Generation of Engines" /> */}
          <VdoCipherComp filename="testengine2" constrainToParent={true} title="Combustion Test"/> 
          {/* <YouTubeVideo videoId="https://youtu.be/IzOiC49GI88" constrainToParent={true} title="Learning More" /> */}
          {/* // <CFOVideo/> */}
        </div>
        {/* )} */}
        <LandingNews />
        <VCenterScroll items={innovationItems} />
      </ScrollPage>
      {/* </div> */}
      {/* <Footer /> */}
    </div>

  );
};

export default LandingPage1;